export default __webpack_public_path__ + "static/media/googlekeep.cca30769.png";